import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

interface ShareButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  inline?: boolean;
}

const ShareButton: React.FC<ShareButtonProps> = ({ onClick, ariaLabel = 'Share AI response', inline = false }) => {
  return (
    <Box
      sx={inline ? {} : {
        position: 'absolute',
        bottom: 12,
        right: 12,
        zIndex: 10,
      }}
    >
      <Tooltip title="Share" placement="top">
        <span>
          <IconButton
            color="primary"
            aria-label={ariaLabel}
            onClick={onClick}
            size="large"
            tabIndex={0}
          >
            <ShareIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default ShareButton; 